export enum DetailView {
    Lobby_Activity = 1,
    Lobby_Editor = 2, 
}